import styled, {css} from 'styled-components'
import {FilterIcon} from '@components/ui/icon/Icon.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledFilterIcon = styled(FilterIcon)<{$filterLength?: number}>`
    ${({$filterLength, theme}) => css`
        & path {
            stroke: ${$filterLength && $filterLength > 0 ? theme.palette.neutral.white : theme.palette.neutral.black};
        }
    `}
`

export const StyledSearchBarWrapper = styled.div`
    ${({theme}) => css`
        display: grid;
        grid-template-columns: 1fr auto;
        width: 100%;
        align-items: center;
        justify-content: flex-start;
        gap: ${theme.spacing * 2}px;
    `}
`

export const StyledContainerChipMobile = styled(Flexbox)`
    ${({theme}) => css`
        padding: ${theme.spacing * 6}px 0 ${theme.spacing * 2}px 0;
        flex-wrap: wrap;
    `}
`

export const ScrollableFlexbox = styled(Flexbox)`
    flex-wrap: wrap;
    max-height: 150px;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`
